import { Box, Flex, Heading, Text, useColorModeValue } from '@chakra-ui/react';
import { GaugeMaxDuotone } from 'components/dashboard/icons/gauge-max-duotone';
import { FaEllipsisH } from 'react-icons/fa';

export interface SsiBoxHeaderProps {
  title: string;
  handleClick?: () => void;
}

export const SsiBoxHeader = ({ title, handleClick }: SsiBoxHeaderProps) => {
  const textLight = useColorModeValue(
    'text.lightMode.inactive',
    'text.darkMode.inactive'
  );
  return (
    <Heading size="sm">
      <Flex justifyContent="space-between" alignItems="center">
        <Flex gap={2} alignItems="center">
          <GaugeMaxDuotone />
          <Text>{title}</Text>
        </Flex>
        {handleClick && (
          <Box color={textLight}>
            <FaEllipsisH />
          </Box>
        )}
      </Flex>
    </Heading>
  );
};
